import { combineReducers } from 'redux'
import Router from './Router'
import KastnerStore from './KastnerStore'
import ScreenSize from './ScreenSize'


export default combineReducers({
  Router, KastnerStore, ScreenSize
})



// WEBPACK FOOTER //
// ./src/reducers/index.js